export default {
  // 模式
  "common.mode.auto": "Përdorim i vetveten e prodhuar",
  "common.mode.economy": "Režim ekonomik",
  "common.mode.exigency": "Režim në mënyrë emergjente",

  // 设备
  "common.grid": "Rrjeti elektrik",
  "common.evChargers": "Stacionet e ngarkimit për makineri elektrike",
  "common.evCharger": "Stacion i ngarkimit për makinë elektrike",
  "common.pv": "Fotovoltaik",
  "common.inverter": "Invertues",
  "common.pcs": "Invertues + bateri",
  "common.terminal": "Pajisja terminale",
  "common.airc": "Klimatizim",
  "common.engine": "Motor",
  "common.battery": "Bateri",
  "common.metter": "Mjer i energjisë elektrike",
  "common.other": "Tjetër",
  "common.power": "Fuqi",
  "common.powerTotal": "Fuqi totale",
  "common.voltage": "Voltazh",
  "common.electricity": "Energjia elektrike",
  "common.current": "Ström (amper)",
  "common.homeUsage": "Ngarkesa totale e shtëpisë",
  "common.battery.power": "Fuqi e baterisë",

  // 数据
  "common.noDataAvailable": "Sëkund të dhëna në dispozicion~",
  "common.tips": "Shënim",
  "common.reset": "Rivendos",
  "common.currencyUnit": "¥",
  "common.submiting": "Po wirdhet, ju lutem prisni...",
  "common.close": "Mbyll",
  "common.from": "nga",
  "common.useIn": "për përdorim në",
  "common.energyPercent": "Përqindja e fluksit të energjisë",
  "common.dataFlow": "Fluks i të dhënave",
  "common.getDataIng": "Po merren të dhënat, ju lutem prisni...",
  "common.pageLoading": "Përmbajtja e faqes po ngarkohet, ju lutem prisni...",
  "common.reseting": "Përmbajtja e faqes po rivendoset, ju lutem prisni...",
  "common.save": "Ruaj",
  "common.onlyNumberTips": "Mund të shkruani vetëm numra",
  "common.offline": "Jashtë rrjetit",
  "common.online": "Në rrjet",
  "common.fault": "Gabim",
  "common.charge": "Ngarkim",
  "common.discharge": "Sharkim",
  "common.buy": "Bli",
  "common.sell": "Shite",
  "common.loadingInfo": "Po ngarkohet, ju lutem prisni...",

  // 
  "common.moreFeatures": "Më shumë funksione",
  "common.confirm": "Konfirmo",
  "common.saveing": "Po ruhet, ju lutem prisni...",
  "common.searchPlacholder": "Shkruani fjalën kyçe për kërkim",
  "common.iSee": "Kam kuptuar",
  "common.pageErrorTips1": "Oops, ndodhi një gabim në faqen web~",
  "common.pageErrorTips2": "Provoni të rivendosni faqen ose kontaktoni mbështetjen~",
  "common.refresh": "Rivendos",
  "common.backToHome": "Kthehu te faqja kryesore",
  "common.checkTips": "Po verifikohet, ju lutem prisni...",
  "common.back": "Kthehu",
  "common.cancel": "Anulo",
  "common.optional": "Opsionale",
  "common.required": "I detyrueshëm",
  "common.status": "Gjendja",
  "common.statusNoDelete": "I papërfshirë",
  "common.statusDelete": "I fshirë",
  "common.submit": "Wirshaj",
  "common.disable": "Çaktivizo",
  "common.enable": "Aktivizo",
  "common.year": "viti",
  "common.month": "muaj",
  "common.day": "ditë",
  "common.version": "Versioni:",
  "common.backHome": " Kthehu te faqja kryesore",
  "common.backHomeSorry": " Më vjen keq, faqja u humbi papritur",
  "common.requestTips1": "Të dhënat po përpunohen, mos wirshaj përsëri",
  "common.requestTips2": "Shënim sistemi",
  "common.requestTips3": "Gjendja e hyrjes ka skaduar, hyni përsëri",
  "common.requestTips4": "Hyr përsëri",
  "common.requestTips5": "Sesioni është i pavlefshëm ose ka skaduar, hyni përsëri.",
  "common.requestTips6": "Gabim në server, ju lutem provoni përsëri më vonë.",
  "common.requestTips7": "Kohë e kërkesës për ndërfaqe sistemi ka skaduar",
  "common.requestTips8": "Ndërfaqe sistemi",
  "common.requestTips9": "Gabim",
  "common.iknow": "Kam kuptuar",
  "common.logoutSuccess": "Dilja e suksesshme",
  
  // 了解更多组件
  "common.knowMore.title": "Për më shumë informacione, kontaktoni Beineng",
  "common.knowMore.email": "Email i kontaktit",
  "common.knowMore.phone": "Numër i telefonit të kontaktit",
  "common.knowMore.wechat": "WeChat i kontaktit",
  "common.knowMore.website": "Adresa e webfaqes zyrtare",
  "common.knowMore.address": "Adresa e kontaktit",
  "common.knowMore.addressDetail": "Dhoma 1205, Dhoma 1301, Blok 5, Rruga Qinghe 8, Huangjingkeng, Komuna Huangjiang, Qyteti Dongguan, Prefektura Guangdong",
  
  // 本地连接组件
  "common.localConnection": "Lidhje lokale",
  "common.operateInApp": "Operoni në aplikacion!",
  
  "common.enbleStaus": "Gjendja e aktivizimit",
  "common.battery.status": "Pa ngarkim dhe pa sharkim",

  "account.forgetThePassword": "Harruara fjalëkalimi",
  "account.logInDirectly": "Hyr direkt",
  "account.tips1": "Faqja po shkon, ju lutem prisni...",
  "account.tips2": "起rrejteni dhe pranoni parimet e përdoruesit para se anything!",
  "account.autoLogin": "Hyrje automatike",
  "account.userLogin": "Hyrja e përdoruesit",
  "account.registerTips": "Nuk keni llogari ende? Klikoni këtu për të regjistruar",
  "account.userEmail": "Emri i përdoruesit / email",
  "account.userEmailTips": "Shkruani emrin e përdoruesit ose emailin",
  "account.password": "Fjalëkalim",
  "account.passwordTips": "Shkruani fjalëkalimin",
  "account.submit": "Wirshaj",
  "account.submitTips": "Po wirdhet, ju lutem prisni...",
  "account.otherLoginTips": "Ose zgjedhni një mënyrë tjetër hyrjeje",
  "account.userRegistration": "Regjistrimi i përdoruesit",
  "account.userName": "Emri i përdoruesit",
  "account.userNameTips": "Shkruani emrin e përdoruesit",
  "account.emailTips1": "Shkruani adresën e emailit",
  "account.emailTips2": "Formati i adresës së emailit është i pavlefshëm",
  "account.phone": "Numër i telefonit",
  "account.phoneTips1": "Shkruani numrin e telefonit",
  "account.phoneTips2": "Numri i telefonit është i pavlefshëm",
  "account.phoneTips3": "Shkruani numrin e telefonit",
  "account.passwordTips1": "Shkruani fjalëkalimin (6-30 karaktere)",
  "account.passwordTips2": "Formati i fjalëkalimit është i pavlefshëm: fjalëkalimi duhet të përmbajë shkronja angleze, numra, nënvizime, viza dhe pika, gjatësi 6-12 karaktere",
  "account.passwordTips3": "Dy fjalëkalimet nuk përputhen, kontrolloni dhe shkruani përsëri!",
  "account.passwordTips4": "Shkruani fjalëkalimin: fjalëkalimi duhet të përmbajë shkronja angleze, numra, nënvizime, viza dhe pika",
  "account.passwordTips5": "Konfirmoni fjalëkalimin",
  "account.passwordTips6": "Shkruani konfirmimin e fjalëkalimit",
  "account.passwordTips7": "Dy fjalëkalimet nuk përputhen, kontrolloni dhe shkruani përsëri!",
  "account.passwordTips8": "Shkruani konfirmimin e fjalëkalimit",
  "account.passwordTips9": "Urime, regjistrimi u bë me sukses!",
  "account.passwordTips10": "Emri i përdoruesit tuaj është:",
  "account.emailIs": "Emaili është:",
  "account.goToLoginPage": "Pas s sekondave do të shkoni automatikisht te faqja e hyrjes",
  "account.goLogin": "Hyr",
  "account.goRegister": "Regjistrohu",
  "account.loginSuccess": "Hyrja e suksesshme",
  "account.email": "Email",
  "account.sologn": "Krijohet një plan energjie specifike për ju me kujdes",
  "account.pleaseAgree": "Kam lexuar dhe pranuar",
  "userAgreement.privacyPolicy": "Politikat e privatësisë",

  "account.code": "Kodi verifikues",
  "account.codeTips": "Shkruani kodin verifikues",
  "account.codeTips2": "Kodi verifikues është i pavlefshëm",

    "account.inviteCodeTips": "Ju lutemi shkruani kodin e ftesës",
    "account.inviteCodeHint": "Ju lutemi kontaktoni instaluesin ose personelin e mirëmbajtjes për të marrë kodin e ftesës",
  "account.modifyPasswordByAccount": "Ndrysho fjalëkalimin përmes llogarisë",
  "account.modifyPasswordByEmail": "Ndrysho fjalëkalimin përmes emailit",
  "account.getPasswordByAccount": "Merr fjalëkalimin përmes llogarisë",
  "account.getPasswordByEmail": "Merr fjalëkalimin përmes emailit",

  "account.sendEmailTips": "Kodi verifikues u dërgua në email, kontrolloni atë",
  "account.name": "Emri i llogarisë",
  "account.newPassword": "Fjalëkalim i ri",
  "account.confirmNewPassword": "Konfirmoni fjalëkalimin e ri",
  "account.nameTips": "Shkruani emrin e llogarisë",
  "account.passwordModifySuccess": "Fjalëkalimi u ndryshua me sukses",
  "account.emailCode": "Kodi verifikues i emailit",
  "account.emailCodeTips": "Shkruani kodin verifikues të emailit",
  "account.emailCodeTips2": "Kodi verifikues i emailit është i pavlefshëm",
  "account.emailModifySuccess": "Fjalëkalimi u ndryshua me sukses",
  "account.passworTips1": "Fjalëkalimi juaj u rivendos me sukses!",
  "account.passwordTips11": "Shkruani konfirmimin e fjalëkalimit",
  "account.passwordTips12": "Shkruani fjalëkalimin e ri",
  "account.nickname": "Pseudonimi i përdoruesit",
  "account.modifyNickname": "Ndrysho pseudonin e përdoruesit",
  "account.modifyNicknameSuccess": "Pseudonimi i përdoruesit u ndryshua me sukses!",
  "account.nicknameTips": "Shkruani pseudonin e përdoruesit",
  "account.nicknameError": "Ndryshimi i pseudonimit të përdoruesit dështoi!",

  "account.login": "Hyr",
  "account.quickRegister": "Regjistrim i shpejtë",
  "account.sendCode": "Dërgo kodin",
  "account.sendTips": "Pas s sekondave mund të dërgoni përsëri",
  "account.sendEmailIng": "Po dërgohet emaili, ju lutem prisni...",
  "account.emailNotEmpty": "Adresa e emailit nuk mund të jetë e zbrazët",
  "account.registerAccount": "Regjistro llogari",
  "account.registerWelcome": "Mirë se vini në regjistrimin e SusprSafe",
  "account.usernameLimit": "Emri i përdoruesit duhet të fillojë me shkronjë dhe vetëm me shkronja, numra dhe nënvizime, gjatësi 5-15 karaktere",

  "copyright.desc2": "Informacioni i regjistrimit të webfaqes: Regjistrim ICP Guangdong Nr. 2021169764",

  "editUserInfo.editUserInformation": "Ndrysho informacionet e përdoruesit",
  "editUserInfo.modifyUsername": "Ndrysho emrin e përdoruesit",
  "editUserInfo.changePictures": "Ndrysho foton e profilit",
  "editUserInfo.savePicturesSuccess": "Fotoja e profilit të përdoruesit u ruaj me sukses",
  "editUserInfo.saveError": "Ruajtja dështoi",
  "editUserInfo.pictureLimit": "Fotoja duhet të jetë më e vogël se 2 MB",
  "editUserInfo.uploadPicture": "Ngarko foton e profilit",
  "editUserInfo.picturePreview": "Parashikim",
  
  "editUserInfo.bindPhoneNumber": "Bindi numrin e telefonit",
  "editUserInfo.bindEmail": "Bindi emailin",
  "editUserInfo.changePassword": "Ndrysho fjalëkalimin",

  "editUserInfo.notificationSettings": "Cilësimet e njoftimeve",
  "editUserInfo.editAccount": "Ndrysho informacionet e llogarisë së përdoruesit",
  "editUserInfo.waitBingting": "Po bëhet binding, ju lutem prisni...",
  "editUserInfo.collapse": "Zgjero",
  "editUserInfo.modifyBinding": "Ndrysho bindingun",
  
  "editUserInfo.emailAddress": "Adresa e emailit",
  "editUserInfo.tips1": "Emaili u bindi me sukses",
  "editUserInfo.tips2": "Ruajtja dështoi",
  "editUserInfo.tips3": "Po dërgohet kodin verifikues të emailit, ju lutem prisni...",
  "editUserInfo.tips4": "Kodi verifikues u dërgua në emailin xxxx, kontrolloni atë",
  "editUserInfo.tips5": "Dërgimi i kodit verifikues dështoi!",
  "editUserInfo.tips6": "Numri i telefonit është i bindur tashmë",
  "editUserInfo.tips7": "Emaili është i bindur tashmë",
  "editUserInfo.emailTips1": "Shkruani adresën e emailit",
  "editUserInfo.emailTips2": "Formati i adresës së emailit është i pavlefshëm",
  "editUserInfo.emailTips3": "Pas xxxx sekondave mund të dërgoni përsëri",
  "editUserInfo.emailTips4": "Dërgo kod",
  "editUserInfo.emailTips5": "Kodi verifikues i emailit nuk mund të jetë i zbrazët",
  "editUserInfo.emailTips6": "Kodi verifikues i emailit është i pavlefshëm",
  "editUserInfo.emailCode": "Kodi verifikues i emailit",
  "editUserInfo.save": "Ruaj",

  "editUserInfo.phoneTips1": "Numri i telefonit u bindi me sukses",
  "editUserInfo.phoneTips2": "Po dërgohet kodin verifikues të SMS, ju lutem prisni...",
  "editUserInfo.phoneTips3": "Kodi verifikues i SMS u dërgua në telefonin xxxx, kontrolloni atë",
  "editUserInfo.phoneTips4": "Dërgimi i kodit verifikues të SMS dështoi!",
  "editUserInfo.phoneTips5": "Shkruani numrin e telefonit",
  "editUserInfo.phoneTips6": "Formati i numrit të telefonit është i pavlefshëm",
  "editUserInfo.phoneTips7": "Dërgo kodin verifikues të SMS",
  "editUserInfo.phoneTips8": "Kodi verifikues i SMS",
  "editUserInfo.phoneTips9": "Kodi verifikues i SMS nuk mund të jetë i zbrazët",
  "editUserInfo.phoneTips10": "Kodi verifikues i SMS është i pavlefshëm",
  "editUserInfo.phone": "Numri i telefonit",


  "editUserInfo.noticeTips1": "Marraja e cilësimeve të njoftimeve dështoi!",
  "editUserInfo.noticeTips2": "Cilësimet e njoftimeve u ruajten me sukses!",
  "editUserInfo.noticeTips3": "Njoftim për nivel të ulët të baterisë",
  "editUserInfo.noticeTips4": "Njoftim për përfundimin e ngarkimit të stacionit të ngarkimit",
  "editUserInfo.errorNotification": "Njoftim për gabim",
  "editUserInfo.updateNotification": "Njoftim për përditësim",
  "editUserInfo.monthlyStatisticsNotification": "Njoftim për statistikat mujore",
  "editUserInfo.notificationMethod": "Mënyra e marrjes",

  "editUserInfo.userNameTips1": "Emri i përdoruesit u ruaj me sukses",
  "editUserInfo.userNameTips2": "Ruajtja e emrit të përdoruesit dështoi",
  "editUserInfo.userNameTips3": "Shkruani emrin e përdoruesit",
  "editUserInfo.userNameTips4": "Formati i emrit të përdoruesit është i pavlefshëm: duhet të përmbajë vetëm numra, nënvizime dhe shkronja angleze",
  "editUserInfo.userNameTips5": "Shkruani emrin e përdoruesit",
  "editUserInfo.userNameTips6": "Po ruhet, ju lutem prisni...",
  "editUserInfo.userName": "Emri i përdoruesit",

  "editUserInfo.avatorTips": "Klikoni për të ndryshuar foton e profilit",
  "editUserInfo.verifyCodeTips1": "Shkruani kodin verifikues që morët:",
  "editUserInfo.verifyCodeTips2": "Për sigurinë e llogarisë suaj, klikoni butonin më poshtë për të dërguar kodin verifikues në numrin e telefonit origjinal:",
  "editUserInfo.verifyCodeTips3": "Dërgo kod",
  "editUserInfo.verifyCodeTips4": "Verifikimi i telefonit origjinal u bë me sukses, shkruani numrin e ri të telefonit të bindur",
  "editUserInfo.verifyCodeTips5": "Për sigurinë e llogarisë suaj, klikoni butonin më poshtë për të dërguar kodin verifikues në emailin origjinal:",
  "editUserInfo.verifyCodeTips6": "Verifikimi i emailit origjinal u bë me sukses, shkruani emailin e ri",
  "editUserInfo.verifyCodeTips7": "Fjalëkalimi i vjetër",
  "editUserInfo.verifyCodeTips8": "Bindi emailin së pari!",
  "editUserInfo.verifyCodeTips9": "Kodi verifikues u dërgua në email, kontrolloni atë",
  "editUserInfo.verifyCodeTips10": ", do të shkoni automatikisht te faqja e hyrjes",

  "hems.notice.title": "Titulli i njoftimit", 
  "hems.notice.content": "Përmbajtja e njoftimit", 
  "hems.notice.operate": "Operacion",
  "hems.notice.noRead": "I paparashikuar",
  "hems.notice.read": "I parashikuar",
  "hems.notice.warning": "Kujtes",
  "hems.notice.error": "Gabim",
  "hems.notice.success": "Fatura statistikore",
  "hems.notice.sys": "Informacion sistemi",
  "hems.notice.operateSuccess": "Operacioni u bë me sukses",
  "hems.notice.operateTips": "Zgjedhini elementin për operacion",

  // 首页
  "hems.home.selfuseRate": "Rata e përdorimit të vetveten",
  "hems.home.percent": "Përqindje",
  "hems.home.todayData": "Të dhënat e sotme",
  "hems.home.todayPowerGeneration": "Prodhimi i energjisë sotëm",
  "hems.home.salesIncome": "Të ardhurat nga shitja e energjisë",
  "hems.home.saved": "Ju keni kursyer",
  "hems.home.reduce": "Zvogëlojeni gjurmën e karbonit",
  "hems.home.tips1": "Sëkund të dhëna në dispozicion, nuk keni bindi xxxx ende",
  "hems.home.criticalLoad": "Ngarkesë kritike",
  "hems.home.keyVoltage": "Voltazh kyç",
  "hems.home.householdLoad": "Ngarkesë e shtëpisë",
  "hems.home.householdVoltage": "Voltazh i shtëpisë",
  "hems.home.generalLoad": "Ngarkesë e zakonshme",
  "hems.home.generalVoltage": "Voltazh i zakonshëm",
  "hems.home.batteryHealth": "Gjendja shëndetësore e baterisë",
  "hems.home.averageTemp": "Temperatura mesatare",
  "hems.home.gridLoad": "Ngarkesë e rrjetit elektrik",
  "hems.home.toggeleDataSource": "Të dhënat e shfaqura aktualisht janë zgjidhur në:",
  "hems.home.toggleTips": "A jeni të sigurt që dëshironi të zgjidhni?",
  "hems.home.modeSending": "Komanda e režimit po dërgohet, ju lutem prisni...",
  "hems.home.modeSuccess": "Komanda e zgjidhjes së režimit u dërgua me sukses!",
  "hems.home.isOnline": "A është në rrjet?",
  "hems.home.useStatus": "Gjendja e përdorimit",
  "hems.home.workModeText": "Režimi i punës aktual:",
  "hems.home.toggleDataSourceText": "Të dhënat e shfaqura aktualisht janë zgjidhur në:",
  "hems.ev.charge.status": "Gjendja e ngarkimit",
  "hems.ev.charge.time": "Koha e ngarkimit",
  "hems.ev.charge.count": "Sasia e ngarkimit në kohën reale",
  "hems.ev.charge.status.empty": "Bosh",
  "hems.ev.charge.status.ing": "Po ngarkohet me kabl",
  "hems.ev.charge.status.null": "Kabl i lidhur por pa ngarkim",
  "hems.ev.charge.status.error": "Gabim",
  "hems.hour": "orë",
  "hems.minue": "minutë",
  "hems.ev.chagre.number": "Numri i stacionit të ngarkimit",

  // User Guide
  "hems.userGuide.selfUse": "Përdorim i vetveten e prodhuar",
  "hems.userGuide.selfUseTips": "Përdorni për të parë energjinë fotovoltaike, në qoftë se nuk është e mjaftueshme, plotësoni nga rrjeti elektrik",
  "hems.userGuide.economyMode": "Režim ekonomik",
  "hems.userGuide.economyModeTips": "Optimizoni strategjinë e përdorimit të energjisë sipas çmimit të elektrikut",
  "hems.userGuide.emergencyMode": "Režim në mënyrë emergjente",
  "hems.userGuide.emergencyModeTips": "Garantoni për ngarkesën kritike për të parë",

  // 图表页面
  "hems.history.energyStatistics": "Statistikat e energjisë",
  "hems.history.revenueStatistics": "Statistikat e të ardhurave",
  "hems.history.greenStatistics": "Zvogëlimi i emisioneve jeshile",
  "hems.history.revenueTitle": "Të ardhurat totale nga shitja e energjisë",
  "hems.history.savingsTitle": "Kursimet totale",
  "hems.history.carbonTitle": "Zvogëlimi total i emisioneve të karbonit",
  "hems.history.day": "Ditë",
  "hems.history.month": "Muaj",
  "hems.history.year": "Viti",
  "hems.history.beforeDay": "Dje",
  "hems.history.afterDay": "Nesër",
  "hems.history.beforeMonth": "Muaji i kaluar",
  "hems.history.afterMonth": "Muaji i ardhshëm",
  "hems.history.beforeYear": "Viti i kaluar",
  "hems.history.afterYear": "Viti i ardhshëm",
  "hems.history.totalUse": "Përdorimi total",
  "hems.history.fullScreen": "Ekran i plotë",
  "hems.history.timeSelect": "Zgjedhja e datës",
  "sync.tips1": "Komanda e sinkronizimit të të dhënave u dërgua me sukses!",
  "sync.tips2": "Sinkronizimi i të dhënave po bëhet, për shkak të madhësisë së të dhënave, procesi duhet një kohë, kontrolloni përsëri pas gjysmë ore~",
  "sync.tips3": "Sinkronizimi i të dhënave të pajisjes mund të ketë kohë të vonuar, në qoftë se gjeni një discrepancë në të dhënat, klikoni në:",
  "sync.tips4": "Sinkronizo të dhënat",

  "charge.info": "Informacionet e stacionit të ngarkimit",
  "news.loading": "Po ngarkohet...",
  "news.noMore": "Nuk ka më elemente",
  "hems.pv.power": "Sasia e energjisë nga fotovoltaika",

  // UEH specific
  "ueh.sellPower": "Sasia e energjisë së shitur",
  
  "menu.home": "Faqja kryesore",
  "menu.history": "Të dhënat e kaluara",
  "menu.device": "Pajisjet",
  "menu.settings": "Cilësimet",
  "menu.messageCenter": "Qendër mesazhesh",
  "menu.help": "Ndihmë dhe mbështetje",
  "menu.mine": "Imja",


  "mine.userSetting": "Cilësimet e përdoruesit",
  "mine.terminalSetting": "Cilësimet bazë të terminalit",
  "mine.uploadCloud": "Backup i të dhënave në cloud",
  "mine.changeVersion": "Kontrolloni përditësimin",
  "mine.language": "Zgjidhni gjuhën",
  "mine.about": "Rreth aplikacionit",
  "mine.feedback": "Feedback",
  "mine.logout": "Dilni nga llogaria",
  "mine.logoutAccount": "Fshini llogarinë",

  "mine.logoutAccountTips": "Fshini llogarinë me emrin []",
  "mine.logoutAccountTips1": "Fshini llogarinë e bindur në []",
  "mine.logoutAccountCare": "Kur kërkoni fshirjen e llogarisë, ju lutem vini re në pikat e mëposhtme:",
  "mine.logoutAccountCare1": "1. Llogaria është në gjendje sigurie",
  "mine.logoutAccountCare1-1": "Llogaria është në gjendje normale përdorimi, pa rrezik të vjedhjes, shkeljes ose bllokimit.",
  "mine.logoutAccountCare2": "2. Autorizimet dhe bindinget e llogarisë janë hequr",
  "mine.logoutAccountCare2-1": "Të gjitha autorizimet e llogarisë me platformat e tretit janë hequr.",
  "mine.logoutAccountCare3": "3. Pas fshirjes së llogarisë nuk mund të rikuhen, të dhënat e përdoruesit do të fshihen",
  "mine.logoutAccountCare3-1": "Pas fshirjes së llogarisë, numri i telefonit, emaili dhe të dhënat e tjera të binduara do të fshihen dhe nuk mund të rikuhen.",
  "mine.confirmLogout": "Konfirmoni fshirjen",
  "mine.logoutSuccess": "Llogaria u fshi me sukses!",


  "mine.feedbackIssues": "Feedback për probleme",
  "mine.feedQuantity": "Sasia",
  "mine.feedAmount": "Maksimum 9 foto, madhësi maksimale 1 MB/foto",

  "mine.notice.fail": "Marraja e cilësimeve të njoftimeve dështoi!",
  "mine.notice.saveSuccess": "Cilësimet e njoftimeve u ruajten me sukses!",
  "mine.notice.saveFail": "Ruajtja dështoi!",
  "mine.notice.title": "Cilësimet e njoftimeve",
  "mine.notice.batteryLow": "Njoftim për nivel të ulët të baterisë",
  "mine.notice.chargingFinish": "Njoftim për përfundimin e ngarkimit të stacionit të ngarkimit",
  "mine.notice.error": "Njoftim për gabim",
  "mine.notice.update": "Njoftim për përditësim",
  "mine.notice.monthly": "Njoftim për statistikat mujore",
  "mine.notice.receiveType": "Mënyra e marrjes",

  "mine.language.welcome": "Mirë se vini në SusprSafe",
  "mine.language.desc1": "Zgjidhni versionin e gjuhës sipas vendit ku jetoni",
  "mine.language.desc2": "Mund të ndryshoni në cilësimet e aplikacionit në çdo kohë",

  "mine.userInfo.avatar": "Foto e profilit",
  "mine.userInfo.nickname": "Pseudonim",
  "mine.userInfo.password": "Fjalëkalim",
  "mine.userInfo.changePassword": "Ndrysho fjalëkalimin",
  "mine.userInfo.setPassword": "Cilësimi i fjalëkalimit",
  "mine.userInfo.phoneNumber": "Numri i telefonit",
  "mine.userInfo.bindPhone": "Bindi numrin e telefonit",
  "mine.userInfo.bindEmail": "Bindi emailin",
  "mine.loginExpired": "Gjendja e hyrjes ka skaduar, hyni përsëri",
  "mine.userInfo.title": "Informacionet e përdoruesit",
  "mine.userInfo.bind": "Bind",
  "mine.userInfo.modify": "Ndrysho",
  "mine.userInfo.modifyNickname": "Ndrysho pseudonin",
  "mine.userInfo.userNickname": "Pseudonimi i përdoruesit",
  "mine.userInfo.selectPic": "Zgjidhni foton për ngarkim",
  "mine.userInfo.saveSuccess": "Ruajtja u bë me sukses",
  "mine.userInfo.uploadFail": "Ngarkimi dështoi",
  "mine.userInfo.avatarSaveSuccess": "Fotoja e profilit u ruaj me sukses",
  "mine.userInfo.nameTips1": "Pseudonimi i përdoruesit nuk mund të jetë i zbrazët",
  "mine.userInfo.nameTips2": "Shkruani pseudonin e përdoruesit",

  "common.pleaseSelect": "Ju lutem zgjidhni",
  "question.commonQuestions": "Pyetjet e shpeshta",
  "account.toggleLanguage": "Zgjidhni gjuhën",
  "account.localConnection": "Lidhje lokale",
  "account.selectLanguage": "Ju lutem zgjidhni gjuhën",
  "account.sendEmailToast": "Kodi verifikues u dërgua në emailin xxx, kontrolloni atë",
  "account.emailError": "Formati i emailit është i pavlefshëm",
  "account.sendEmailFail": "Dërgimi dështoi, provoni përsëri",
  
  "common.submitting": "Po wirdhet, ju lutem prisni...",

  "device.page.noData": "Sëkund të dhëna në dispozicion, faqja këtë mund të parashikoni vetëm në aplikacion"
,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};